export default __webpack_public_path__ + "static/media/vluna.27aaad3d.png";